var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-subheader',[_vm._v("Maps")]),_vm._l((_vm.buildings),function(building,i){return _c('div',{key:i},[_c('v-list-item',{attrs:{"link":"","to":'/maps/'+building}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-map-outline")])],1),_c('v-list-item-title',[_vm._v("Building "+_vm._s(building))])],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }